import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedImagesTabsQueryParamsType,
  GetDamagedImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImagesTabs/getDamagedImagesTabsQuery.type';

export const getInitialVisitImagesTabFunction = (
  params: GetDamagedImagesTabsQueryParamsType,
): Promise<GetDamagedImagesTabsQueryResponseType> => {
  return fetchApi.get(`/initial/reports/${params?.id}/images/entry_tabs/`);
};
